import styled from "styled-components";

import { themeGet } from "@styled-system/theme-get";

const SiteNavLogo = styled.img`
    position: absolute;
    left: -35px;
    top: 8px;
    display: block;
    height: 22px;
    @media screen and (max-width: calc(${themeGet("breakpoints.xl")} + 80px)) {
        position: relative;
        top: auto;
        left: -10px;
    }
    @media screen and (max-width: ${themeGet("breakpoints.md")}) {
        left: 0;
    }
`;

SiteNavLogo.displayName = "SiteNavLogo";

export default SiteNavLogo;
